<div class="flex flex-col gap-medpace">
    <mds-text-field
        appGoogleMapsAutocomplete
        (placeChangeEvent)="googleMapsAutocompletePlaceChange($event, formGrp().controls.fromLocation)"
        id="FromLocationField"
        data-cy="fromLocationField"
        [formCtrl]="formGrp().controls.fromLocation"
        placeholder="Enter address here"
        appearance="outline"
        label="From Location"
    ></mds-text-field>
    <mds-text-field
        appGoogleMapsAutocomplete
        (placeChangeEvent)="googleMapsAutocompletePlaceChange($event, formGrp().controls.toLocation)"
        id="ToLocationField"
        [formCtrl]="formGrp().controls.toLocation"
        placeholder="Enter address here"
        appearance="outline"
        label="To Location"
    ></mds-text-field>

    <div class="grid grid-cols-3 gap-medpace">
        <mds-datepicker
            id="TransactionDatePicker"
            data-cy="transactionDatePicker"
            [formCtrl]="expenseFormGroup().controls.receiptDate"
            appearance="outline"
            label="Receipt Date"
            [placeholder]="'Select date'"
        ></mds-datepicker>
        <mds-dropdown
            [label]="'Country'"
            [placeholder]="'Select country'"
            [options]="countryOptions()"
            [filterable]="true"
            [appearance]="'outline'"
            [closeOnPageScroll]="false"
            id="country"
            [formCtrl]="formGrp().controls.country"
        ></mds-dropdown>
    </div>
    @if (elevatedAccess()) {
        <mds-checkbox
            label="Manual Total Calculation"
            id="ManualTotalCalculation"
            [formCtrl]="formGrp().controls.manualTotalCalculation"
        />
    }
    @if ((isIncomplete$ | async) === true) {
        @if (elevatedAccess()) {
            <medpace-alert
                content="Either the reimbursement rate for this country is not available or the currency in the
                            country does not match the currency of the request. Use the manual total calculation to
                            enter a reimbursement rate and total manually."
            />
        } @else {
            <medpace-alert
                content="Either the reimbursement rate for this country is not available or the currency in the
                        country does not match the currency of the request."
            />
        }
    }
    <div class="grid grid-cols-3 gap-medpace">
        <mds-text-field
            id="ReimbursementRate"
            [inputType]="'decimal'"
            [decimalPlaces]="3"
            placeholder="Type here..."
            appearance="outline"
            label="Reimbursement Rate (per distance unit)"
            width="100%"
            [formCtrl]="formGrp().controls.reimbursementRate"
        />
        <mds-dropdown
            [filterable]="true"
            [closeOnPageScroll]="false"
            appearance="outline"
            label="Currency"
            placeholder="Select currency"
            [options]="(currencyOptions$ | async) ?? []"
            id="filterDropdown"
            [formCtrl]="expenseFormGroup().controls.currency"
        ></mds-dropdown>
    </div>
    <div class="grid grid-cols-3 gap-medpace">
        <mds-text-field
            appDisableMouseScroll
            id="TotalDistanceField"
            [formCtrl]="formGrp().controls.totalDistance"
            inputType="decimal"
            [decimalPlaces]="2"
            placeholder="Type here..."
            appearance="outline"
            label="Total Distance"
            width="100%"
        />
        <mds-radio-group
            [label]="'Distance Unit'"
            [buttons]="distanceUnit_RadioButtons"
            [formCtrl]="formGrp().controls.distanceUnit"
            id="distanceUnit"
        />
    </div>

    <mds-textarea
        id="CommentField"
        [formCtrl]="formGrp().controls.comment"
        [label]="'Additional Details'"
        [appearance]="'outline'"
        [placeholder]="'Type here...'"
        [autoSize]="true"
        [cdkAutosizeMinRows]="4"
        [cdkAutosizeMaxRows]="8"
    />

    <div class="grid grid-cols-3 gap-medpace">
        <mds-text-field
            appDisableMouseScroll
            id="AmountToAuthorizeField"
            data-cy="amountToAuthorizeField"
            [formCtrl]="formGrp().controls.requestedAmountInLocalCurrency"
            inputType="decimal"
            [decimalPlaces]="2"
            placeholder="Type here..."
            appearance="outline"
            [label]="requestedLabel$ | async"
        ></mds-text-field>
        @if (isInProcessOrHigherAndHasElevatedAccess$ | async) {
            <mds-text-field
                appDisableMouseScroll
                id="AuthorizedAmountField"
                data-cy="authorizedAmountField"
                [formCtrl]="formGrp().controls.authorizedAmountInLocalCurrency"
                inputType="decimal"
                [decimalPlaces]="2"
                placeholder="Type here..."
                appearance="outline"
                [label]="authorizedLabel$ | async"
            ></mds-text-field>
        }
    </div>
    @if (isInProcessOrHigherAndHasElevatedAccess$ | async) {
        <div class="flex flex-row gap-medpace">
            @if (authorizedAmountPatientsCurrencyChip()) {
                <mds-chip
                    [chips]="authorizedAmountPatientsCurrencyChip()"
                    [chipListType]="'basic'"
                    [multiple]="true"
                ></mds-chip>
            }
            @if (authorizedAmountUSDChip()) {
                <mds-chip [chips]="authorizedAmountUSDChip()" [chipListType]="'basic'" [multiple]="true"></mds-chip>
            }
        </div>
    }
</div>
